var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function CheckSmallIconInner(props) {
    return (React.createElement("svg", __assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.8839 2.76608C15.372 3.25423 15.372 4.04569 14.8839 4.53385L6.53388 12.8839C6.29894 13.1188 5.98013 13.2505 5.64787 13.25C5.31561 13.2494 4.99725 13.1166 4.76311 12.8808L1.1131 9.20584C0.626619 8.71602 0.62932 7.92457 1.11914 7.43808C1.60896 6.95159 2.40041 6.9543 2.8869 7.44411L5.65302 10.2292L13.1161 2.76608C13.6043 2.27792 14.3957 2.27792 14.8839 2.76608Z", fill: "" })));
}
export var CheckSmallIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: CheckSmallIconInner }, props))); };
//# sourceMappingURL=CheckSmallIcon.js.map